export type ViewStatsCategory = 'person' | 'face'

export const getCategoryFromId = (id: string | number): ViewStatsCategory => +id === 1 ? 'person' : 'face'